import React from 'react'
import { Modal } from "antd"

const ClosingProcessReasonModal = ({showModal, onCloseModal, children}) => {
  return (
    <Modal
      title="Motivo de cierre"
      visible={showModal}
      onCancel={onCloseModal}
      footer={null}
    >
      {children}
    </Modal>
  )
}

export default ClosingProcessReasonModal;